import React, { Component } from 'react';
import axios from 'axios';

import LoadSpinner from './loadSpinner';
import ToggleBtn from './toggleBtn';

var searchInt = null;

class AddressBook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addressLetterKey: {},
            addressLetters: ["A","B","C","D","E","F","G","H","I","J","K","L","M",
                            "N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
            addressResults: [],
            searchQuery:"",
            searchToggle: false,
            searchCountDown: 3,
            loading: false,
            activePoints:{}
        }

        /* References */
        this.addressRef = React.createRef();
        this.groupRef = React.createRef();

        this.toggleSearch = this.toggleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.scrollToGroup = this.scrollToGroup.bind(this);
        this.moveCtrl = this.moveCtrl.bind(this);
        this.sortAddressList = this.sortAddressList.bind(this);
        this.addressQuery = this.addressQuery.bind(this);
        this.togglePoint = this.togglePoint.bind(this);
        this.addAddress = this.addAddress.bind(this);
    }

    toggleSearch(){
        try {
            this.setState({ searchToggle: !this.state.searchToggle });
        }
        catch(ex){
            console.log("[Error] Toggling Search: ",ex);
        }
    }

    handleChange(e){
        var self = this;
        try {
            var name = e.target.name;
            var value = e.target.value;
            
            this.setState({ [name]: value }, () =>{
                clearInterval(searchInt);
                self.setState({ searchCountDown: 3 });
                searchInt = setInterval(function(){
                    self.setState({ searchCountDown: self.state.searchCountDown - 1 }, () =>{
                        if(self.state.searchCountDown <= 0){
                            clearInterval(searchInt);
                            searchInt = null;
                            self.addressQuery();
                        }
                    });
                }, 750);
            });
        }
        catch(ex){
            console.log("[Error] Handling Search Change: ",ex);
        }
    }

    scrollToGroup(group){
        try {
            group = group.toLowerCase();
            var myElement = document.getElementById(group);

            if(myElement){
                this.groupRef.current.scrollTop = myElement.offsetTop - myElement.scrollHeight;
            }
        }
        catch(ex){
            console.log("[Error] Scrolling To Group: ",ex);
        }
    }

    moveCtrl(dir, ref, scrollInt){
        try {  
            if(ref && ref.current) {
                var tmpPos = ref.current.scrollLeft + (scrollInt * dir);
                ref.current.scrollLeft = tmpPos;     
            }           
        }
        catch(ex){
            console.log("[Error] Moving Direction: ",ex);
        }
    }

    sortAddressList(list){
        try {
            var tmpAddressResults = [];
            list.sort(function(a,b){ 
                var nameA = a.name.toLowerCase(); 
                var nameB = b.name.toLowerCase(); 
                if (nameA < nameB) { return -1; }
                if (nameA > nameB) { return 1;  }

                return 0;
            });

            var tmpLtr = { letter: "", list:[]};
            var letterkey = {};

            for(var i =0; i < list.length; i++){
                if(tmpLtr.letter === ""){
                    tmpLtr.letter = list[i].name[0];
                    tmpLtr.list = [ list[i] ];
                }
                else if(list[i].name[0] === tmpLtr.letter){
                    tmpLtr.list.push(list[i]);
                }
                else {
                    tmpAddressResults.push(JSON.parse(JSON.stringify(tmpLtr)));
                    tmpLtr.letter = list[i].name[0];
                    tmpLtr.list = [ list[i] ];
                }

                letterkey[list[i].name[0]] = true;
            }

            if(tmpLtr.list.length > 0){
                tmpAddressResults.push(JSON.parse(JSON.stringify(tmpLtr)));
            }

            this.setState({ addressResults: tmpAddressResults, addressLetterKey: letterkey });
        }
        catch(ex){
            console.log("[Error] Sorting Address List", ex);
        }
    }

    addressQuery(){
        var self = this;
        try {
            var user = this.props.checkUser(false,true);

            this.setState({ loading: true }, ()=>{
                var postData = { "user": user, "searchtype":"name", "size": -1, "location": { "name": this.state.searchQuery, "address":"","city":"","state":"","zip":"" } };
                axios.post(self.props.baseUrl + "/fillmore/location/search", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error || !response.data.results){
                            console.log(" [Error] Getting Location Search Results: ", response.data.error);
                            self.setState({ loading: false });
                        }
                        else {
                            self.setState({ loading: false}, () =>{ 
                                self.sortAddressList(response.data.results.locations);
                            });
                        }
                    });   
            });
            
        }
        catch(ex){
            console.log("[Error] Quering Address: ",ex);
        }
    }

    togglePoint(address){
        try {
            var tmpActive = this.state.activePoints;
            var pt = (address.info && address.info.length > 0 ? address.info[0] : null);
            var editData = (address.info && address.info.length > 0 ? address.info[0] : {});

            if(address.name in tmpActive){
                // Remove Point
                delete tmpActive[address.name];
                this.props.toggleMapPoint(pt, false, editData);
            }
            else {
                // Add Point
                tmpActive[address.name] = true;
                editData.name = address.name; 
                editData.user = this.props.checkUser(false,true);
                this.props.toggleMapPoint(pt, true, editData);
            }

            this.setState({ activePoints: tmpActive });
        }
        catch(ex){
            console.log("[Error] Toggling Point: ",ex);
        }
    }

    addAddress() {
        try {
            this.props.newSelectedItem({ user: this.props.checkUser(false,true), name:"", address:"", city:"", state:"", zip:"" }, true, false);
        }
        catch(ex){
            console.log(" [Error] Adding Address: ",ex);
        }
    }

    componentDidMount() {
        try {
            this.addressQuery();
        }
        catch(ex){
            console.log(" [Error]  Starting: ",ex);
        }
    }

    render(){   
        return(            
            <div className="content-section address">
                {this.state.loading && <LoadSpinner userClass="fillmore" /> }
                <div className="section-title">
                    <h2>Address Book</h2>

                    <div className="title-btn-container">
                        <div className="title-btn toggle-btn">
                            <div className={"tro-btn tro-input" + (this.state.searchToggle ? "" : " closed")}>
                                <input value={this.state.searchQuery} name="searchQuery" placeholder="Search Address Book" autoComplete="off" onChange={this.handleChange} />
                                <div className="btn-icon" onClick={this.toggleSearch}><i className={"fas " + (this.state.searchToggle ? "fa-compress-arrows-alt" : "fa-search")} /></div>
                            </div>
                            {(searchInt !== null && this.state.searchCountDown > 0) && <div className="search-countdown">{this.state.searchCountDown}</div> }
                        </div>
                        <div className="title-btn icon-btn" onClick={this.addAddress}><i className="fas fa-plus" /></div>
                    </div>
                </div>
                {/* Letter List */}
                <div className="sel-group">
                    <div className="sel-ctrl left" onClick={() => this.moveCtrl(-1,this.addressRef, 400)}><i className="fas fa-angle-left" /></div>
                    <div className="sel-group-container" ref={this.addressRef}>
                        {this.state.addressLetters.map((item,i) =>
                            <div className={"sel-item" + (item.toLowerCase() in this.state.addressLetterKey ? "" : " disabled")} key={i} onClick={()=> this.scrollToGroup(item)}><span>{item}</span></div>
                        )}
                    </div>
                    <div className="sel-ctrl right" onClick={() => this.moveCtrl(1,this.addressRef, 400)}><i className="fas fa-angle-right" /></div>
                </div>

                {/* Address List */}
                <div className="address-list" ref={this.groupRef}>
                    {this.state.addressResults.map((item,i) =>
                        <div id={item.letter} className="address-group" key={i} >
                            <div className="group-title"><span>{item.letter}</span></div>
                            {item.list.map((address,j) =>
                                <div className={"address-item" + (address.name in this.state.activePoints ? " sel":"")} key={j} onClick={() => this.togglePoint(address)}>
                                    <span className="item-icon" />
                                    <div className="item-name" >{address.name}</div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>                              
        );
    }
}

/* User Schedule */
class UserSchedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userList:[],
            selUser:null,
            selSchedule:[],
            dayList:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
            loading: false,
            activePoints:{},
            curDay:0,
            selDay: 0
        }

        /* References */
        this.usersRef = React.createRef();

        this.moveCtrl = this.moveCtrl.bind(this);
        this.formatTime = this.formatTime.bind(this);
        this.getUserList = this.getUserList.bind(this);
        this.getUserSchedule = this.getUserSchedule.bind(this);
        this.selUser = this.selUser.bind(this);
        this.timeFormatter = this.timeFormatter.bind(this);
        this.togglePoint = this.togglePoint.bind(this);
        this.addEvent = this.addEvent.bind(this);
        this.addHome = this.addHome.bind(this);
        this.setSelDay = this.setSelDay.bind(this);
    }

    moveCtrl(dir, ref, scrollInt){
        try {  
            if(ref && ref.current) {
                var tmpPos = ref.current.scrollLeft + (scrollInt * dir);
                ref.current.scrollLeft = tmpPos;     
            }           
        }
        catch(ex){
            console.log("[Error] Moving Direction: ",ex);
        }
    }

    
    formatTime(time){
        var ret = "00:00";

        try {
            var tmpStr = time.toString();
            while(tmpStr.length < 4){
                tmpStr = "0" + tmpStr;
            }

            ret = tmpStr.substring(0,2) + ":" + tmpStr.substring(2);
        }
        catch(ex){
            console.log("[Error] Formatting Time: ",ex);
        }

        return ret;
    }

    getUserList(){
        var self = this;
        try {
            var user = this.props.checkUser(false,false);

            this.setState({ loading: true }, () => {
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                axios.get(self.props.baseUrl + "/api/auth/getUsers", { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting User List Results: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {                       
                        self.setState({ loading: false, userList: response.data.results});
                    }
                });    
            }); 
        }
        catch(ex){
            console.log("[Error] Getting User List: ", ex);
        }
    }

    getUserSchedule(day){
        var self = this;
        try {
            this.setState({ loading: true }, () => {
                var postData = { "user": self.state.selUser, "day":day };

                axios.post(self.props.baseUrl + "/fillmore/schedule/view", postData, {'Content-Type': 'application/json'})
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting User Schedule Results: ", response.data.error);
                        self.setState({ loading: false, selSchedule:[] });
                    }

                    else {                       
                        self.setState({ loading: false, selSchedule: (!response.data.results ? []: response.data.results.schedule) });
                    }
                });    
            });
        }
        catch(ex){
            console.log("[Error] Getting User Schedule: ",ex);
        }
    }

    selUser(user){
        var self = this;
        try {
            this.setState({ selUser: user }, ()=>{  
                self.props.newSelectedItem(null, false, false);         
                self.getUserSchedule(self.state.selDay);
            });
        }
        catch(ex){
            console.log("[Error] Selecting User: ",ex);
        }
    }

    timeFormatter(time){
        var ret = time;
        try {
            var fourDigitTime = "", time = time.toString().split("");
            while(fourDigitTime.length < 4){
                if(time.length > 0) {
                    fourDigitTime = time.pop() + fourDigitTime;
                }
                else {
                    fourDigitTime = "0" + fourDigitTime;
                }
            }

            var hours24 = parseInt(fourDigitTime.substring(0,2));
            var hours = ((hours24 + 11) % 12) + 1;
            var amPm = hours24 > 11 ? 'pm' : 'am';
            var minutes = fourDigitTime.substring(2);
            
            ret = hours + ':' + minutes + amPm;
        }
        catch(ex){
            console.log("[Error] Formatting Time: ",ex);
        }
        return ret;
    }

    togglePoint(event){
        try {
            var tmpActive = this.state.activePoints;
            var pt = (event.info && event.info.length > 0 ? event.info[0] : null);
            var editData = (event.info && event.info.length > 0 ? event.info[0] : {});            

            if(event.title in tmpActive){
                // Remove Point
                delete tmpActive[event.title];
                this.props.toggleMapPoint(pt, false, editData);
            }
            else {
                // Add Point
                tmpActive[event.title] = true;
 
                editData.user = this.state.selUser;
                editData.title = event.title;
                editData.type = event.type;
                editData.day = event.day;
                editData.startTime = this.formatTime(event.startTime);
                editData.endTime = this.formatTime(event.endTime);
                editData.locationId = event.locationId;

                this.props.toggleMapPoint(pt, true, editData);
            }

            this.setState({ activePoints: tmpActive });
        }
        catch(ex){
            console.log("[Error] Toggling Point: ",ex);
        }
    }

    addEvent() {
        try {
            this.props.newSelectedItem({ user: this.state.selUser, type:"", day:"", title:"", startTime:"00:00", endTime:"00:00", locationId:null, address:"", city:"", state:"", zip:"" }, true, false);
        }
        catch(ex){
            console.log(" [Error] Adding Event: ",ex);
        }
    }

    addHome(){
        try {
            this.props.newSelectedItem({ user: this.state.selUser, name:"Home", address:"", city:"", state:"", zip:"" }, true, true);
        }
        catch(ex){
            console.log(" [Error] Adding Home: ",ex);
        }
    }

    setSelDay(day){
        var self = this;
        try {
            this.setState({ selDay: day }, () =>{
                self.getUserSchedule(self.state.selDay);
            });
        }
        catch(ex){
            console.log(" [Error] Adding Address: ",ex);
        }
    }

    componentDidMount() {
        var self = this;
        try {
            var d = new Date();
            this.getUserList();
            var user = self.props.checkUser(false,true);

            if(user){
                this.setState({ curDay: d.getDay(), selDay: d.getDay(), selUser: user }, ()=>{                
                    self.getUserSchedule(self.state.selDay);  
                });
            }
        }
        catch(ex){
            console.log("[Error] Starting: ",ex);
        }
    }

    render(){   
        return(  
            <div className="content-section schedule">
                {this.state.loading && <LoadSpinner userClass="fillmore" /> }
                <div className="section-title">
                    <h2>User Schedule</h2>

                    <div className="title-btn-container">
                        {(this.state.selUser && this.state.selUser.hasHome === false) && <div className="title-btn icon-btn" onClick={this.addHome}><i className="fas fa-house-user" /></div> }
                        <div className="title-btn icon-btn c2" onClick={()=> this.props.estimateLocation(this.state.selUser)}><i className="fas fa-route" /></div>
                        <div className="title-btn icon-btn" onClick={this.addEvent}><i className="fas fa-plus" /></div>
                    </div>
                </div>
                {/* User List */}
                <div className="sel-group">
                    <div className="sel-ctrl left" onClick={() => this.moveCtrl(-1,this.usersRef, 360)}><i className="fas fa-angle-left" /></div>
                    <div className="sel-group-container" ref={this.usersRef}>
                        {this.state.userList.map((item,i) =>
                            <div className={"sel-item" + ((this.state.selUser && (item._id === this.state.selUser._id)) ? " sel" : "")} key={i} onClick={()=> this.selUser(item)}>
                                <div className="user-icon"><i className="fas fa-user-astronaut" /></div>
                                <div className="user-name">{item.name.split(" ").map((name,j) => <div key={j}>{name}</div>)}</div>
                            </div>
                        )}
                    </div>
                    <div className="sel-ctrl right" onClick={() => this.moveCtrl(1,this.usersRef, 360)}><i className="fas fa-angle-right" /></div>
                </div>

                {/* Schedule */}
                <div className="schedule-list">
                    {this.state.selSchedule.length == 0 && <div className="no-data">No Events For This Day</div>}
                    {this.state.selSchedule.map((item,i) =>
                        <div className={"schedule-item" + (item.title in this.state.activePoints ? " sel":"")} key={i} onClick={()=> this.togglePoint(item)}>
                             <div className="item-row">
                                <div className="row-item bubble">{this.state.dayList[item.day]}</div>
                                <div className="row-item text">
                                    <i className="far fa-clock" />
                                    <span>{this.timeFormatter(item.startTime)} - {this.timeFormatter(item.endTime)}</span>
                                </div>
                            </div>

                            <div className="item-row"><div className="row-item title">{item.title}</div></div>
                            
                            {(item.info && item.info.length > 0) && 
                                <div className="item-row">
                                    <div className="row-item text">
                                        <i className="fas fa-map-marker-alt" />
                                        <span>{item.info[0].address},</span>
                                        <span>{item.info[0].city},</span>
                                        <span>{item.info[0].state}</span>
                                        <span>{item.info[0].zip}</span>
                                    </div>
                                </div>     
                            }                           
                        </div>
                    )}                                        
                </div>

                {/* Day List */}
                <div className="day-list">
                    {this.state.dayList.map((day,i)=>
                        <div className={"day-item" +(i == this.state.selDay ? " sel":"")} key={i} onClick={()=> this.setSelDay(i)}>{day} {this.state.curDay === i && <span className="curDay"/> }</div>
                    )}
                </div>
            </div>  
        );
    }
}

/* Add/Update Address */
class EditAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }

        this.isNewAddress = this.isNewAddress.bind(this);
        this.saveAddress = this.saveAddress.bind(this);
    }

    isNewAddress(){
        var ret = false;
        try {
            ret = (this.props.selectedItem && !this.props.selectedItem.lng && !this.props.selectedItem.lat);
        }
        catch(ex){
            console.log("[Error] Checking Address Status: ",ex);
        }

        return ret;
    }

    saveAddress(){
        var self = this;
        try {
            if(this.props.selectedItem.name.length == 0) { alert("No Nickname"); }
            else if(this.props.selectedItem.address.length == 0) { alert("No Address"); }
            else if(this.props.selectedItem.city.length == 0) { alert("No City"); }
            else if(this.props.selectedItem.state.length < 2) { alert("Incorrect State Abbr."); }
            else if(this.props.selectedItem.zip.length < 5) { alert("Incorrect Zip Code"); }
            else {
                var postData = { 
                    "user": this.props.selectedItem.user, 
                    "location": { 
                        "name": this.props.selectedItem.name, "address": this.props.selectedItem.address,
                        "city": this.props.selectedItem.city, "state": this.props.selectedItem.state,
                        "zip": this.props.selectedItem.zip
                    } 
                };
                
                this.setState({ loading: true }, () => {
                    axios.post(self.props.baseUrl + "/fillmore/location/add", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error || !response.data.results){
                            console.log("[Error] Saving Location: ", response.data.error);
                            self.setState({ loading: false });
                        }
                        else {                       
                            self.setState({ loading: false }, () => { 
                                alert("Location Saved");
                                self.props.resetSliders(false);
                            });
                        }
                    }); 
                });               
            }
        }
        catch(ex){
            console.log("[Error] Saving Location: ",ex);
        }
    }

    componentDidMount() {}

    render(){   
        return(  
            <div className="editor-section address">
                {this.state.loading && <LoadSpinner userClass="fillmore" /> }
                <div className="slider-input add">
                    <div className="slider-title">
                        <span className="title-txt">{(this.isNewAddress() ? "Add Address" : "View Address")}</span>

                        <div className="btn-container">
                            {this.isNewAddress() && 
                                <div className="tro-btn btn" onClick={this.saveAddress}>
                                    <div className="btn-txt">Save</div>
                                    <div className="btn-icon"><i className="far fa-save" /></div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="slider-title">
                        <div className="sub-txt">For: <span>{(this.props.selectedItem.user ? this.props.selectedItem.user.name : "N/A")}</span></div>
                    </div>

                    <div className="input-field sz-10">
                        <span>Nickname</span>
                        <input type="text" name="name" autoComplete="off" value={this.props.selectedItem.name} onChange={this.props.handleChange} disabled={(this.isNewAddress() ? "" : "disabled")}/>
                    </div>

                    <div className="input-field sz-10">
                        <span>Address</span>
                        <input type="text" name="address" value={this.props.selectedItem.address} onChange={this.props.handleChange} disabled={(this.isNewAddress() ? "" : "disabled")} />
                    </div>

                    <div className="input-field sz-4">
                        <span>City</span>
                        <input type="text" name="city" value={this.props.selectedItem.city} onChange={this.props.handleChange} disabled={(this.isNewAddress() ? "" : "disabled")} />
                    </div>

                    <div className="input-field sz-3">
                        <span>State</span>
                        <input type="text" name="state" value={this.props.selectedItem.state} onChange={this.props.handleChange} disabled={(this.isNewAddress() ? "" : "disabled")} />
                    </div>

                    <div className="input-field sz-3">
                        <span>Zip</span>
                        <input type="text" name="zip" value={this.props.selectedItem.zip} onChange={this.props.handleChange} disabled={(this.isNewAddress() ? "" : "disabled")} />
                    </div>
                </div>                
            </div>
        );
    }
}

/* Add/Update Event */
class EditEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            locationList:[],
            address:"", city:"",
            state:"", zip:"", locationId:null
        }

        /* References */
        this.addressRef = React.createRef();

        this.moveCtrl = this.moveCtrl.bind(this);
        this.isNewEvent = this.isNewEvent.bind(this);
        this.validateEvent = this.validateEvent.bind(this);
        this.saveEvent = this.saveEvent.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.searchAddress = this.searchAddress.bind(this);
        this.selAddress = this.selAddress.bind(this);
    }

    moveCtrl(dir, ref, scrollInt){
        try {  
            if(ref && ref.current) {
                var tmpPos = ref.current.scrollLeft + (scrollInt * dir);
                ref.current.scrollLeft = tmpPos;     
            }           
        }
        catch(ex){
            console.log("[Error] Moving Direction: ",ex);
        }
    }

    isNewEvent(){
        var ret = false;
        try {
            ret = (this.props.selectedItem && !this.props.selectedItem.lng && !this.props.selectedItem.lat);
        }
        catch(ex){
            console.log("[Error] Checking Address Status: ",ex);
        }

        return ret;
    }

    validateEvent(event){
        var status = [];
        try {
            // User Check
            if(!event.user) { status.push("Invalid User");}

            // Event Check
            if(!event) { status.push("Invalid Event Object"); }
            else {
                var eventItems = ["type", "title"];
                eventItems.forEach(function(item){
                    if(!event.event[item] || event.event[item].length == 0) { status.push("Missing Event " + item);}
                });
            }

            // Day Check
            if(event.event.type === "weekly" && (!event.event.day || event.event.day.length == 0)){
                status.push("Select Day For Weekly Event Type");
            }

            // Time Check
            if(event.event.startTime == event.event.endTime){
                status.push("Start & End Time's Must Be Different");
            }
            else if(event.event.startTime > event.event.endTime){
                status.push("End Time Must Be After Start Time");
            }

            // Location Check
            if(!event.locationId){
                var locationItems = ["address", "city","state","zip"];
                locationItems.forEach(function(item){
                    if(!event.location[item] || event.location[item].length == 0) { status.push("Missing Location " + item);}
                });
            }

        }
        catch(ex){
            console.log("[Error] Validaging Event: ",ex);
        }

        return status;
    }

    saveEvent(){
        var self = this;
        try {
            var postValidation = [];
            //TODO: Unformat Dates
            var tmpStart = this.props.selectedItem.startTime.split(":").join("");
            var tmpEnd = this.props.selectedItem.endTime.split(":").join("");            

            this.setState({ loading: true }, ()=> {
                if(self.props.selectedItem.locationId){
                    // Save Event
                    var postData = { "user": self.props.selectedItem.user, "event": { 
                        "type": self.props.selectedItem.type, "day": parseInt(self.props.selectedItem.day || "0"), 
                        "title": self.props.selectedItem.title, "locationId": self.props.selectedItem.locationId,
                        "startTime": parseInt(tmpStart) , "endTime": parseInt(tmpEnd)
                    }};

                    postValidation = self.validateEvent(postData);
                    if(postValidation.length > 0){
                        self.setState({ loading: false}, () => {
                            alert("Event Error: " + postValidation.join("; "));
                        });
                    }
                    else {
                    axios.post(self.props.baseUrl + "/fillmore/schedule/add", postData, {'Content-Type': 'application/json'})
                        .then(function(response) {
                            if(response.data.error || !response.data.results){
                                console.log(" [Error] Adding Event: ", response.data.error);
                                self.setState({ loading: false });
                            }
                            else {
                                self.setState({ loading: false}, () => {
                                    alert("Event Added ");
                                    self.props.resetSliders(false);
                                });
                            }
                        }); 
                    }
                }
                else {
                    var postData = { "user": self.props.selectedItem.user, "event": { 
                        "type": self.props.selectedItem.type, "day": parseInt(self.props.selectedItem.day), 
                        "title": self.props.selectedItem.title, "locationId": null,
                        "startTime": parseInt(tmpStart) , "endTime": parseInt(tmpEnd)
                    }, "location":{
                        "address":self.props.selectedItem.address, "city":self.props.selectedItem.city, 
                        "state":self.props.selectedItem.state, "zip":self.props.selectedItem.zip
                    }};

                    postValidation = self.validateEvent(postData);
                    if(postValidation.length > 0){
                        self.setState({ loading: false}, () => {
                            alert("Event Error: " + postValidation.join("; "));
                        });
                    }
                    else {                    
                        axios.post(self.props.baseUrl + "/fillmore/schedule/addLocation", postData, {'Content-Type': 'application/json'})
                        .then(function(response) {
                            if(response.data.error || !response.data.results){
                                console.log(" [Error] Adding Location Event: ", response.data.error);
                                self.setState({ loading: false });
                            }
                            else {
                                self.setState({ loading: false}, () => {
                                    alert("Event Added ");
                                    self.props.resetSliders(true);
                                });
                            }
                        });
                    }
                }
                console.log(postData);
                self.setState({ loading: false });
            });
        }
        catch(ex){
            console.log("[Error] Saving Event: ",ex);
        }
    }

    handleChange(e){
        try {
            this.props.handleChange(e);
            var tmpAddress = { 
                "address":this.props.selectedItem.address, "state":this.props.selectedItem.state,
                "city":this.props.selectedItem.city, "zip":this.props.selectedItem.zip
            };
            tmpAddress[e.target.name] = e.target.value;

            this.searchAddress(tmpAddress);
        }
        catch(ex){
            console.log("[Error] Handling Change: ",ex);
        }
    }

    searchAddress(searchAddress){
        var self = this;
        try {
            var user = this.props.checkUser(false,true);

            this.setState({ loading: true }, ()=> {
                var postData = { "user": user, "searchtype":"address", "size": -1, "location": { "name": "", "address":searchAddress.address,"city":searchAddress.city, "state":searchAddress.state, "zip":searchAddress.zip } };
                axios.post(self.props.baseUrl + "/fillmore/location/search", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error || !response.data.results){
                            console.log(" [Error] Getting Location Search Results: ", response.data.error);
                            self.setState({ loading: false, locationList:[] });
                        }
                        else {
                            self.setState({ loading: false, locationList: response.data.results });
                        }
                    });   
            });
        }
        catch(ex){
            console.log("[Error] Searching Address: ",ex);
        }
    }

    selAddress(item){
        var self = this;
        try {
            this.setState({ locationList: []}, ()=> {
                var tmpSelection = self.props.selectedItem;

                tmpSelection.address = item.address; 
                tmpSelection.city = item.city;
                tmpSelection.state = item.state; 
                tmpSelection.zip = item.zip; 
                tmpSelection.locationId = item._id;

                self.props.addressSelection(tmpSelection, true, false);
            });
        }
        catch(ex){
            console.log("[Error] Setting Address: ",ex);
        }
    }

    componentDidMount() {}

    render(){   
        return(  
            <div className="editor-section schedule">
                {this.state.loading && <LoadSpinner userClass="fillmore" /> }
                <div className="slider-input add">
                    <div className="slider-title">
                        <span className="title-txt">{(this.isNewEvent() ? "Add Event" : "View Event")}</span>

                        <div className="btn-container">
                            {this.isNewEvent() && 
                                <div className="tro-btn btn" onClick={this.saveEvent}>
                                    <div className="btn-txt">Save</div>
                                    <div className="btn-icon"><i className="far fa-save" /></div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="slider-title">
                        <div className="sub-txt">For: <span>{(this.props.selectedItem.user ? this.props.selectedItem.user.name : "N/A")}</span></div>
                    </div>

                    <div className="input-field sz-10">
                        <span>Title</span>
                        <input type="text" name="title" autoComplete="off" value={this.props.selectedItem.title} onChange={this.props.handleChange} disabled={(this.isNewEvent() ? "" : "disabled")}/>
                    </div>
                            
                    <div className="input-field sz-6">
                        <span>Event Type</span>
                        {(this.isNewEvent() ? 
                            <ToggleBtn toggles={["weekly","workWeek","daily"]} selected={this.props.selectedItem.type} name="type" handleChange={this.props.handleChange} />
                        : <input type="text" name="type" value={this.props.selectedItem.type} disabled={"disabled"}/> )}
                    </div>

                    <div className="input-field sz-4">
                        <span>Day</span>
                        <select name="day" value={this.props.selectedItem.day} onChange={this.props.handleChange} disabled={(this.isNewEvent() ? "" : "disabled")}>
                            <option value />
                            <option value="0">Sunday</option><option value="1">Monday</option>
                            <option value="2">Tuesday</option><option value="3">Wednesday</option>
                            <option value="4">Thursday</option><option value="5">Friday</option>
                            <option value="6">Saturday</option>                            
                        </select>
                    </div>

                    <div className="input-field sz-5">
                        <span>Start Time</span>
                        <input type="time" name="startTime" autoComplete="off" value={this.props.selectedItem.startTime} onChange={this.props.handleChange} disabled={(this.isNewEvent() ? "" : "disabled")}/>
                    </div>

                    <div className="input-field sz-5">
                        <span>End Time</span>
                        <input type="time" name="endTime" autoComplete="off" value={this.props.selectedItem.endTime} onChange={this.props.handleChange} disabled={(this.isNewEvent() ? "" : "disabled")}/>
                    </div>

                    <div className="slider-title mid">
                        <div className="sub-txt">Event Location</div>

                        <div className="btn-container">
                            {(this.props.selectedItem.locationId && this.isNewEvent()) && 
                                <div className="tro-btn btn" onClick={()=> this.selAddress({ "address":"", "city":"", "state":"","zip":"","_id":null})}>
                                    <div className="btn-txt">Clear</div>
                                    <div className="btn-icon"><i className="fas fa-backspace" /></div>
                                </div>
                            }
                        </div>
                    </div>
                    
                    <div className="input-field sz-10">
                        <span>Address</span>
                        <input type="text" name="address" value={this.props.selectedItem.address} onChange={this.handleChange} disabled={(!this.props.selectedItem.locationId ? "" : "disabled")} />
                    </div>

                    <div className="input-field sz-4">
                        <span>City</span>
                        <input type="text" name="city" value={this.props.selectedItem.city} onChange={this.handleChange} disabled={(!this.props.selectedItem.locationId ? "" : "disabled")} />
                    </div>

                    <div className="input-field sz-3">
                        <span>State</span>
                        <input type="text" name="state" value={this.props.selectedItem.state} onChange={this.handleChange} disabled={(!this.props.selectedItem.locationId ? "" : "disabled")} />
                    </div>

                    <div className="input-field sz-3">
                        <span>Zip</span>
                        <input type="text" name="zip" value={this.props.selectedItem.zip} onChange={this.handleChange} disabled={(!this.props.selectedItem.locationId ? "" : "disabled")} />
                    </div>                    
                </div>  

                {/* locationList */}
                <div className="sel-group">
                    <div className="sel-ctrl left" onClick={() => this.moveCtrl(-1,this.addressRef, 360)}><i className="fas fa-angle-left" /></div>
                    <div className="sel-group-container" ref={this.addressRef}>
                        {this.state.locationList.map((item,i) =>
                            <div className="sel-item" key={i} onClick={()=> this.selAddress(item)}>
                                <div className="item-row">{item.address}</div>
                                <div className="item-row">{item.city}, {item.state} {item.zip}</div>
                            </div>
                        )}
                    </div>
                    <div className="sel-ctrl right" onClick={() => this.moveCtrl(1,this.addressRef, 360)}><i className="fas fa-angle-right" /></div>
                </div>             
            </div>
        );
    }
}

export { AddressBook, UserSchedule, EditAddress, EditEvent };